/* NgRx */
import {createAction, props} from '@ngrx/store';
import {Filter} from "../../../../models/filter";
import {GroupsList} from "../../../../models/groups-list";
import {
  FetchParticipantsAndCaregiversListModel
} from '../../clients-list/model/fetch-participants-and-caregivers-list.model';
import {
  ParticipantsAndCaregiversList
} from '../../../../models/participants-and-caregivers-list';
import {
  FetchGroupFilterModel
} from '../../clients-list/model/fetch-group-filter.model';
import {
  FetchParticipantsWeightListModel
} from '../../clients-list/model/fetch-participants-weight-list.model';
import {
  ParticipantsWeightList
} from '../../../../models/participants-weight-list';
import {
  ParticipantsBehaviourList
} from "../../../../models/participants-behaviour-list";


/******** CLEAR STATE ***********/
const CLEAR_STATE = '[admin groups list] clear state';
export const ClearState = createAction(CLEAR_STATE);

/*********** FETCH DASHBOARD FILTER **************/
const FETCH_DASHBOARD_FILTER_REQUEST = '[admin groups list] fetch dashboard filter requested';
export const FetchDashboardFilterRequest = createAction(FETCH_DASHBOARD_FILTER_REQUEST);

const FETCH_DASHBOARD_FILTER_SUCCESS = '[admin groups list] fetch dashboard filter successful';
export const FetchDashboardFilterSuccess = createAction(FETCH_DASHBOARD_FILTER_SUCCESS, props<{
  dashboardFilter: Filter,
  message: string
}>());

const FETCH_DASHBOARD_FILTER_FAILURE = '[admin groups list] fetch dashboard filter failure';
export const FetchDashboardFilterFailure = createAction(FETCH_DASHBOARD_FILTER_FAILURE, props<{
  message: string
}>());

/******** FETCH GROUPS LIST ***********/
const FETCH_GROUPS_LIST_REQUEST = '[admin groups list] fetch groups list request';
export const FetchGroupsListRequest = createAction(FETCH_GROUPS_LIST_REQUEST, props<any>());

const FETCH_GROUPS_LIST_SUCCESS = '[admin groups list] fetch groups list success';
export const FetchGroupsListSuccess = createAction(FETCH_GROUPS_LIST_SUCCESS, props<{
  groupsList: GroupsList,
  message: string
}>());

const FETCH_GROUPS_LIST_FAILURE = '[admin groups list] fetch groups list failure';
export const FetchGroupsListFailure = createAction(FETCH_GROUPS_LIST_FAILURE);

/*********** FETCH CLINIC FILTER **************/
const FETCH_CLINIC_FILTER_REQUEST = '[admin groups list] fetch clinic filter requested';
export const FetchClinicFilterRequest = createAction(FETCH_CLINIC_FILTER_REQUEST);

const FETCH_CLINIC_FILTER_SUCCESS = '[admin groups list] fetch clinic filter successful';
export const FetchClinicFilterSuccess = createAction(FETCH_CLINIC_FILTER_SUCCESS, props<{
  clinicFilter: Filter,
  message: string
}>());

const FETCH_CLINIC_FILTER_FAILURE = '[admin groups list] fetch status filter failure';
export const FetchClinicFilterFailure = createAction(FETCH_CLINIC_FILTER_FAILURE, props<{
  message: string
}>());

/*********** FETCH STATUS FILTER **************/
const FETCH_STATUS_FILTER_REQUEST = '[admin groups list] fetch status filter requested';
export const FetchStatusFilterRequest = createAction(FETCH_STATUS_FILTER_REQUEST);

const FETCH_STATUS_FILTER_SUCCESS = '[admin groups list] fetch status filter successful';
export const FetchStatusFilterSuccess = createAction(FETCH_STATUS_FILTER_SUCCESS, props<{
  statusFilter: Filter,
  message: string
}>());

const FETCH_STATUS_FILTER_FAILURE = '[admin groups list] fetch status filter failure';
export const FetchStatusFilterFailure = createAction(FETCH_STATUS_FILTER_FAILURE, props<{
  message: string
}>());

/*********** FETCH GROUP TYPE FILTER **************/
const FETCH_GROUP_TYPE_FILTER_REQUEST = '[admin groups list] fetch group type filter requested';
export const FetchGroupTypeFilterRequest = createAction(FETCH_GROUP_TYPE_FILTER_REQUEST);

const FETCH_GROUP_TYPE_FILTER_SUCCESS = '[admin groups list] fetch group type filter successful';
export const FetchGroupTypeFilterSuccess = createAction(FETCH_GROUP_TYPE_FILTER_SUCCESS, props<{
  groupTypeFilter: Filter,
  message: string
}>());

const FETCH_GROUP_TYPE_FILTER_FAILURE = '[admin groups list] fetch group type filter failure';
export const FetchGroupTypeFilterFailure = createAction(FETCH_GROUP_TYPE_FILTER_FAILURE, props<{
  message: string
}>());

/******** FETCH PARTICIPANT AND CAREGIVERS LIST ***********/
const FETCH_PARTICIPANT_AND_CAREGIVERS_LIST_REQUEST = '[admin groups list] fetch participants and caregivers list request';
export const FetchParticipantsAndCaregiversListRequest = createAction(FETCH_PARTICIPANT_AND_CAREGIVERS_LIST_REQUEST, props<{
  payload: FetchParticipantsAndCaregiversListModel['request']
}>());

const FETCH_PARTICIPANT_AND_CAREGIVERS_LIST_SUCCESS = '[admin groups list] fetch participants and caregivers list success';
export const FetchParticipantsAndCaregiversListSuccess = createAction(FETCH_PARTICIPANT_AND_CAREGIVERS_LIST_SUCCESS, props<{
  participantsAndCaregiversList: ParticipantsAndCaregiversList,
  message: string
}>());

const FETCH_PARTICIPANT_AND_CAREGIVERS_LIST_FAILURE = '[admin groups list] fetch participants and caregivers list failure';
export const FetchParticipantsAndCaregiversListFailure = createAction(FETCH_PARTICIPANT_AND_CAREGIVERS_LIST_FAILURE);

/*********** FETCH GROUP LIST FILTER **************/
const FETCH_GROUP_LIST_FILTER_REQUEST = '[admin groups list] fetch group list filter requested';
export const FetchGroupListFilterRequest = createAction(FETCH_GROUP_LIST_FILTER_REQUEST, props<{
  payload: FetchGroupFilterModel['request']
}>());

const FETCH_GROUP_LIST_FILTER_SUCCESS = '[admin groups list] fetch group list filter successful';
export const FetchGroupListFilterSuccess = createAction(FETCH_GROUP_LIST_FILTER_SUCCESS, props<{
  data: Filter,
  message: string
}>());

const FETCH_GROUP_LIST_FILTER_FAILURE = '[admin groups list] fetch group list filter failure';
export const FetchGroupListFilterFailure = createAction(FETCH_GROUP_LIST_FILTER_FAILURE, props<{
  message: string
}>());

/*********** FETCH USER STATUS FILTER LIST **************/
const FETCH_USER_STATUS_LIST_FILTER_REQUEST = '[admin groups list] fetch user status lists filter requested';
export const FetchUserStatusListFilterRequest = createAction(FETCH_USER_STATUS_LIST_FILTER_REQUEST);

const FETCH_USER_STATUS_LIST_FILTER_SUCCESS = '[admin groups list] fetch user status lists filter successful';
export const FetchUserStatusListFilterSuccess = createAction(FETCH_USER_STATUS_LIST_FILTER_SUCCESS, props<{
  data: Filter,
  message: string
}>());

const FETCH_USER_STATUS_LIST_FILTER_FAILURE = '[admin groups list] fetch user status lists filter failure';
export const FetchUserStatusListFilterFailure = createAction(FETCH_USER_STATUS_LIST_FILTER_FAILURE, props<{
  message: string
}>());

/******** FETCH PARTICIPANT WEIGHT LIST ***********/
const FETCH_PARTICIPANTS_WEIGHT_LIST_REQUEST = '[admin groups list] fetch participants weight list request';
export const FetchParticipantsWeightListRequest = createAction(FETCH_PARTICIPANTS_WEIGHT_LIST_REQUEST, props<{ payload: FetchParticipantsWeightListModel['request'] }>());

const FETCH_PARTICIPANTS_WEIGHT_LIST_SUCCESS = '[admin groups list] fetch participants weight list success';
export const FetchParticipantsWeightListSuccess = createAction(FETCH_PARTICIPANTS_WEIGHT_LIST_SUCCESS, props<{
  participantsWeightList: ParticipantsWeightList,
  message: string
}>());

const FETCH_PARTICIPANTS_WEIGHT_LIST_FAILURE = '[admin groups list] fetch participants weight list failure';
export const FetchParticipantsWeightListFailure = createAction(FETCH_PARTICIPANTS_WEIGHT_LIST_FAILURE);

/*********** SAVE CONFIG ID **************/
const SAVE_CONFIG_ID = '[admin groups list] save config id';
export const SaveConfigId = createAction(SAVE_CONFIG_ID, props<{ configId: number }>());

/******** FETCH PARTICIPANT BEHAVIOUR LIST ***********/
const FETCH_PARTICIPANTS_BEHAVIOUR_LIST_REQUEST = '[admin groups list] fetch participants behaviour list request';
export const FetchParticipantsBehaviourListRequest = createAction(FETCH_PARTICIPANTS_BEHAVIOUR_LIST_REQUEST, props<any>());

const FETCH_PARTICIPANTS_BEHAVIOUR_LIST_SUCCESS = '[admin groups list] fetch participants behaviour list success';
export const FetchParticipantsBehaviourListSuccess = createAction(FETCH_PARTICIPANTS_BEHAVIOUR_LIST_SUCCESS, props<{
  participantsBehaviourList: ParticipantsBehaviourList,
  message: string
}>());

const FETCH_PARTICIPANTS_BEHAVIOUR_LIST_FAILURE = '[admin groups list] fetch participants behaviour list failure';
export const FetchParticipantsBehaviourListFailure = createAction(FETCH_PARTICIPANTS_BEHAVIOUR_LIST_FAILURE);

